import React, { PureComponent } from "react";
import moment from "moment-timezone";
import EngagementOvertimeChart from "./EngagementOvertimeChart";
import { downloadCSVData, downloadCanvasWithTitle, getViewConversationDuration } from "../utils";
import html2canvas from "html2canvas";
import IntervalSelector from "../IntervalSelector";
import NoData from "../NoData/NoData";
import { ReactComponent as MoreOptions } from "../../../../../assets/svg/menu.svg";
import ChartOptionsSidebar from "../ChartsOptionsSidebar/ChartOptionsSidebar";
import CustomCheckBox from "../ChartsOptionsSidebar/CustomCheckBox";
import DeleteWidget from "../ChartsOptionsSidebar/DeleteWidget";
import { ReactComponent as CloneIcon } from "../../../../../assets/svg/clone-icon.svg";
import { ReactComponent as Settings } from "../../../../../assets/svg/settings.svg";
import { showChartsDrilldown } from "../../../../../actions/dashboardAction";
import { ChartFilterIcon } from "../ChartFilterOptions";
import ChartName from "../ChartName";
import { connect } from "react-redux";
import DownloadChart from "../DownloadChart";
import { ReactComponent as MiniMize } from "../../../../../assets/svg/zoom_in_map.svg";
import { ReactComponent as MaxiMize } from "../../../../../assets/svg/zoom_out_map.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";

import { ReactComponent as ComparisionIcon } from "../../../../../assets/svg/CompareChartIcon.svg";
import * as d3 from "d3";

class EngagementOvertime extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            showInfo: false,
            aggs_val: "default",
        };
        this.chartEl = React.createRef();
    }

    downloadCSV = () => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }
        let data = this.formatData(this.props.data.chartData);
        let formatString = "YYYY-MM-DD HH:mm";
        let userTz = JSON.parse(localStorage.getItem("company")).user_timezone_name;
        // data.columns[0] = data.columns[0].map((d) => (d === "x" ? "x" : moment(d).tz(userTz).format(formatString)));
        // let csvFmt = data.columns[0].map((col, i) => data.columns.map((row) => row[i]));

        data.columns[0] = data.columns[0].map((d) => (d === "x" ? "x" : moment(d).tz(userTz).format(formatString)));
        if (this.props.comparisionData) {
            data.columns[2] = data.columns[2].map((d) => (d === "Comparison Time" ? "Comparison Time" : moment(d).tz(userTz).format(formatString)));
        }
        // let csvFmt;
        // if (this.props.comparisionData) {
        //     csvFmt = data.columns[3].map((col, i) => data.columns.map((row) => (row[i] ? row[i] : )));
        // } else {
        //     csvFmt = data.columns[0].map((col, i) => data.columns.map((row) => row[i]));
        // }

        // csvFmt[0][0] = "Time";

        // downloadCSVData(csvFmt, this.props.widget.name);
        let firstIndLen = data.columns[0].length;
        let lastIndLen = data.columns[data.columns.length - 1].length;

        let length;
        if (firstIndLen > lastIndLen) length = firstIndLen;
        else length = lastIndLen;

        let arr = [];
        for (let i = 0; i < length; i++) {
            arr.push([]);
            for (let j = 0; j < data.columns.length; j++) {
                if (data.columns[j] && data.columns[j][i]) arr[i].push(data.columns[j][i]);
                else arr[i].push(0);
            }
        }

        // let csvFmt;
        // if (this.props.comparisionData) {
        //     csvFmt = data.columns[3].map((col, i) => data.columns.map((row) => (row[i] ? row[i] : 0)));
        // } else {
        //     csvFmt = data.columns[0].map((col, i) => data.columns.map((row) => row[i]));
        // }

        arr[0][0] = "Time";

        downloadCSVData(arr, this.props.widget.name);
    };

    downloadPNG = (cb, options) => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }
        html2canvas(this.chartEl.current, { backgroundColor: options.background ? "#fff" : null, allowTaint: true, useCORS: true }).then((canvas) => {
            cb && cb();
            downloadCanvasWithTitle(canvas, this.props.widget.name);
        });
    };

    renderDownloadButton(nodata) {
        return (
            <DownloadChart
                nodata={nodata}
                options={[
                    { name: "CSV", downloadFn: this.downloadCSV },
                    {
                        name: "PNG",
                        downloadFn: this.downloadPNG,
                        showLoader: true,
                        background: true,
                    },
                    {
                        name: "PNG(Transparent)",
                        downloadFn: this.downloadPNG,
                        showLoader: true,
                        background: false,
                    },
                ]}
            />
        );
    }

    formatData(data) {
        let res = {};
        let columns = [];
        let dates = ["x"];
        let values = ["Impact Score"];
        let datesComparision = ["Comparison Time"];
        let valuesComparision = ["Comparison Impact Score"];

        if (data) {
            data.forEach((d) => {
                dates.push(d.x);
                values.push(d.y);
            });
        }

        if (this.props.comparisionData) {
            this.props.comparisionData.chartData.forEach((d) => {
                datesComparision.push(d.x);
                valuesComparision.push(d.y);
            });
        }

        columns.push(dates);
        columns.push(values);

        if (this.props.comparisionData) {
            columns.push(datesComparision);
            columns.push(valuesComparision);
        }

        res.columns = columns;
        return res;
    }

    addContextMenuListener = (x, y, chart) => {
        if (this.props.isPublic) return;
        let self = this;
        let contextMenu = d3.select(".dashboard-charts-contextmenu");

        contextMenu.attr("data-type", "clickedMenu");
        contextMenu.style("top", `${y + 10}px`);
        contextMenu.style("left", `${x - 82}px`);
        contextMenu.style("background", `#fff`);
        contextMenu.style("color", `#1a1a1a`);
        contextMenu.html(null);
        contextMenu
            .append("li")
            .text("View Conversations")
            .on("click", () => {
                self.handleContextMenuClick(chart);
            });
        contextMenu
            .append("li")
            .text("View Insights")
            .on("click", () => {
                // console.log('drilldown')
                self.handleDrilldownClick(chart);
                // this.props.showChartsDrilldown(true, "engagementOverTime");
            });
        contextMenu.style("display", "block");
    };

    createNewFilter(d) {
        let newFilter = this.props.filters ? JSON.parse(JSON.stringify(this.props.filters)) : {};
        if (d.originalX) {
            d.x = d.originalX;
        }
        let lastComparisonIndex = false;
        lastComparisonIndex = d.index === d.series.points.length - 1 && d.color.endsWith("55");

        newFilter.extras = [{ key: "Impact", value: "impact score" }];

        newFilter = getViewConversationDuration(
            d,
            newFilter,
            this.props.aggs_val,
            this.props.filters,
            this.props.comparisionData,
            lastComparisonIndex,
            this.props.comparisonAppliedFilter,
        );
        // newFilter = getViewConversationDuration(d, newFilter, this.props.aggs_val, this.props.filters);
        return newFilter;
    }

    handleContextMenuClick(d) {
        let newFilter = this.createNewFilter(d);

        this.props.handleContextMenuClick(newFilter);
    }

    handleDrilldownClick(d) {
        let newFilter = this.createNewFilter(d);

        this.props.handleDrilldownClick(newFilter);
    }

    handleIntervalChange = (val) => {
        this.props.handleIntervalChange(val);
    };

    render() {
        let nodata = !this.props.data || (this.props.data && this.props.data.nodata) || this.props.noTopicsSelected;

        return (
            <>
                <div className="dashboard-widget-container-header skiptranslate">
                    <ChartName
                        name={this.props.widget.name}
                        info="Represents how impact values have changed overtime across the period for the topics selected as per the filters."
                    />
                    <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                        {!this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <Popup
                                    content="Chart Comparison Filters"
                                    position="bottom center"
                                    size="tiny"
                                    inverted
                                    className="skiptranslate"
                                    trigger={
                                        <div className={`chart-header-icon`} onClick={() => (!this.props.isPublic ? this.props.chartComparision() : null)}>
                                            <ComparisionIcon className={`comparision-filter${this.props.chartComparisionFilterApplied ? "-applied" : ""}`} />
                                        </div>
                                    }
                                />
                            )}
                        {!this.props.isPublic &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <ChartFilterIcon
                                    chartFilterApplied={this.props.chartFilterApplied}
                                    changeShowChartFilterOptions={this.props.changeChartFilter}
                                    widgetListDashboardCurrent={this.props.widgetListDashboardCurrent}
                                    name={this.props.widget.name}
                                />
                            )}
                        {!this.props.isPublic && !this.props.isResearchDashboard && this.renderDownloadButton(nodata)}
                        {
                            <>
                                {this.props.isPublic && nodata ? null : (
                                    <Popup
                                        className="skiptranslate"
                                        trigger={
                                            this.props.expandWidget ? (
                                                <MiniMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                            ) : (
                                                <MaxiMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                            )
                                        }
                                        inverted
                                        content={this.props.expandWidget ? "Minimize Widget" : "Maximize Widget"}
                                        size="mini"
                                        position="bottom center"
                                        style={{ zIndex: "99999" }}
                                    />
                                )}
                            </>
                        }
                        {this.props.isPublic && nodata ? null : <MoreOptions className="more-options" onClick={(e) => this.props.changeShowMoreOptions(e)} />}
                    </div>
                </div>
                {this.props.showMoreOptions && (
                    <ChartOptionsSidebar
                        data-html2canvas-ignore="true"
                        showMoreOptionsLoc={this.props.showMoreOptionsLoc}
                        changeShowMoreOptions={this.props.changeShowMoreOptions}>
                        {!nodata && <CustomCheckBox checked={this.props.showLegend} onClick={this.props.changeShowLegend} label="Show Legends" />}
                        {!nodata && <CustomCheckBox label="Show Grid Lines" checked={this.props.showGridLines} onClick={this.props.changeShowGridLines} />}
                        {!nodata && (
                            <IntervalSelector
                                aggs_val={this.props.aggs_val}
                                appliedFilter={this.props.appliedFilter}
                                handleIntervalChange={this.props.handleIntervalChange}
                                disableComparisonInterval={this.props.disableComparisonInterval}
                            />
                        )}
                        {!this.props.isPublic &&
                            !this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <>
                                    <div className="chart-settings menu-option" onClick={this.props.chartSettings}>
                                        <span>Chart Configuration</span>
                                        <Settings />
                                    </div>
                                    <div className="clone-chart menu-option" onClick={this.props.cloneWidget}>
                                        <span>Clone Chart</span>
                                        <CloneIcon />
                                    </div>
                                </>
                            )}
                        {!this.props.isPublic &&
                            !this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && <DeleteWidget onClick={this.props.deleteWidget} />}
                    </ChartOptionsSidebar>
                )}
                {!nodata ? (
                    <div className="dashboard-chart skiptranslate engagement-overtime" ref={this.chartEl}>
                        <EngagementOvertimeChart
                            data={this.props.data}
                            // resizedCount={this.props.resizedCount}
                            showGridLines={this.props.showGridLines}
                            addContextMenuListener={this.addContextMenuListener}
                            showLegend={this.props.showLegend}
                            comparisionData={this.props.comparisionData}
                            widgetContainerRef={this.props.widgetContainerRef}
                        />
                    </div>
                ) : (
                    <NoData
                        message={
                            !this.props.isPublic && this.props.noTopicsSelected
                                ? "To view charts, please select topics using either the page filters on the left or the chart filters on this chart."
                                : null
                        }
                    />
                )}
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        // allPlatforms: state.globalReducer.filterOptions ? state.globalReducer.filterOptions.platforms : [],
        allPlatforms: state.filterSettingReducer.masterPlatforms,
        widgetListDashboardCurrent: state.dashboardReducer.widgetListDashboardCurrent,
        maximizeWidgetValue: state.dashboardReducer.maximizeWidgetValue,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        showChartsDrilldown: (bool, name) => dispatch(showChartsDrilldown(bool, name)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(EngagementOvertime);
